import * as React from "react";
import { forwardRef } from "react";
const SvgIcSteady20 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.707 10.293V11.707L11.707 17.707L10.293 16.293L14.5859 12H2V10H14.5859L10.293 5.70703L11.707 4.29297L17.707 10.293Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcSteady20);
export { ForwardRef as ReactComponent };
